import { render, staticRenderFns } from "./ListScroll.vue?vue&type=template&id=07806488&scoped=true&"
import script from "./ListScroll.vue?vue&type=script&lang=js&"
export * from "./ListScroll.vue?vue&type=script&lang=js&"
import style0 from "./ListScroll.vue?vue&type=style&index=0&id=07806488&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07806488",
  null
  
)

export default component.exports